/**
 * Skipp header: per top-level menu item gradient + active pill (data attributes from Header blocks).
 */
(function () {
  var LINK_SEL = 'a[data-skipp-theme="1"]';

  function getHeaderWrap() {
    var sec = document.querySelector('.shopify-section.section-header');
    var w = null;
    if (sec) {
      w =
        sec.querySelector('.header-wrapper--skipp-nav-theme') ||
        sec.querySelector('.header-wrapper--skipp-desktop') ||
        sec.querySelector('.header-wrapper');
    }
    return (
      w ||
      document.querySelector('.header-wrapper--skipp-nav-theme') ||
      document.querySelector('.header-wrapper--skipp-desktop') ||
      document.querySelector('.header-wrapper')
    );
  }

  function clearActiveStyles(a) {
    a.style.removeProperty('background-color');
    a.style.removeProperty('color');
    a.style.removeProperty('padding');
    a.style.removeProperty('border-radius');
    a.style.removeProperty('box-shadow');
  }

  function applyTheme(el) {
    var wrap = getHeaderWrap();
    if (!wrap || !el.dataset.skippGTop) return;

    wrap.style.setProperty('--skipp-nav-grad-top', el.dataset.skippGTop);
    wrap.style.setProperty('--skipp-nav-grad-mid', el.dataset.skippGMid);
    wrap.style.setProperty('--skipp-nav-grad-bottom', el.dataset.skippGBottom);
    var stop = el.dataset.skippGStop || '32';
    if (stop.indexOf('%') === -1) stop = stop + '%';
    wrap.style.setProperty('--skipp-nav-grad-stop', stop);

    document.querySelectorAll(LINK_SEL).forEach(function (a) {
      a.classList.remove('active');
      clearActiveStyles(a);
    });
    el.classList.add('active');

    if (el.closest && el.closest('.modern-header__nav-links--bar')) {
      return;
    }

    el.style.setProperty('background-color', el.dataset.skippPillBg, 'important');
    el.style.setProperty('color', el.dataset.skippPillText, 'important');

    var px = el.dataset.skippPadX;
    var py = el.dataset.skippPadY;
    var r = el.dataset.skippRadius;
    if (px != null && py != null) {
      el.style.setProperty('padding', py + 'px ' + px + 'px', 'important');
    }
    if (r != null && r !== '') {
      el.style.setProperty('border-radius', r + 'px', 'important');
    }
    var sh = el.dataset.skippPillShadow;
    if (sh != null && String(sh).trim() !== '') {
      el.style.setProperty('box-shadow', sh, 'important');
    }
  }

  function init() {
    document.querySelectorAll(LINK_SEL).forEach(function (a) {
      if (a.dataset.skippBound === '1') return;
      a.dataset.skippBound = '1';
      a.addEventListener('click', function () {
        applyTheme(this);
      });
    });
    var active = document.querySelector(LINK_SEL + '.active');
    if (active && active.dataset.skippGTop) {
      applyTheme(active);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
